module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"prop-header\"><span class=\"prop-label\">Border</span></div>\r\n<div class=\"row prop-detail\">\r\n    <div class=\"row\">\r\n        <div class=\"col-md-6\" style=\"display: inline-flex;\">\r\n            <input type=\"color\" id=\"borderColorPicker\" value=\"")
    ; __append(escapeFn(borderColor))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" />\r\n            <input type=\"text\" id=\"borderColor\" name=\"borderColor\" maxlength=\"7\" class=\"color-picker-text\" style=\"float:right; margin-left: 2px;\" value=\"")
    ; __append(escapeFn(borderColor))
    ; __append("\" />\r\n        </div>\r\n\r\n    </div>\r\n</div>")
  }
  return __output;

}